import { CommonModule } from '@angular/common';
import { Component, } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { indicador } from '../../../../modal/Indicador';
import { orgao } from '../../../../modal/regional/orgao';

import {
  CdkDragDrop,
  CdkDropList,
  CdkDragPreview,
  CdkDrag,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { OrgaoService } from '../../../../service/orgao.service';


@Component({
  selector: 'app-mudar-posicao-orgao',
  standalone: true,
  imports: [
    CdkDropList, CdkDrag, CdkDragPreview,
    MatSidenavModule,
    MatCardModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    FormsModule,
    MatPaginatorModule
  ],
  templateUrl: './mudar-posicao-orgao.component.html',
  styleUrl: './mudar-posicao-orgao.component.scss'
})
export class MudarPosicaoOrgaoComponent {
  public listaOrgao: orgao[] = [];
  data = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orgaoService: OrgaoService,
    public dialog: MatDialog) {
    try {
      let login = localStorage.getItem('login');
      if (login == null || login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
  }
  ngOnInit() {
    
    this.orgaoService.getAllOrdenacaoOrgao().pipe(
    ).subscribe((response) => {
      this.data = response["Orgao"];
     
      let i = 0;
     
      this.data.forEach(element => {
        i++;
        var org = new orgao(
          element['id'],
          element['codigo'],
          element['descricao'],
          element['codigoCentralizado'],     
          element['nomeApresentacao'],       
          element['ordenacaoOrgao'],         
          element['posicaoOrdenacao']        
        );
        org.posicaoOrdenacao = element['posicaoOrdenacao'];
        this.listaOrgao.push(org);
      });
      this.listaOrgao = this.listaOrgao.sort((a, b) => {       
        if (a.posicaoOrdenacao === undefined) return 1;       
        if (b.posicaoOrdenacao === undefined) return -1;       
        return a.posicaoOrdenacao - b.posicaoOrdenacao; });
    });
  }

  submitForm() {
    var index = 1;
    this.listaOrgao.forEach(element => {

          element['id'],
          element['codigo'],
          element['descricao'],
          element['codigoCentralizado'],     
          element['nomeApresentacao'],       
          element['ordenacaoOrgao'],         
          element['posicaoOrdenacao']   
      element.posicaoOrdenacao = index;
      index++;
    });
    console.log('submit');
    this.orgaoService.alterarPosições(this.listaOrgao).subscribe(() => {
      console.log('Posições alteradas com sucesso');
      alert("Salvo com sucesso!");
    }, error => {
      console.error('Erro:', error);
    });
  }

  drop(event: CdkDragDrop<indicador>) {
    moveItemInArray(this.listaOrgao, event.previousIndex, event.currentIndex);
    //console.log(this.listaOrgao);
  }
}
